<div class="auth-shell-root">
  <div
    class="auth-shell-outlet"
    [@.disabled]="prefersReducedMotion()"
    [@authRouteAnim]="prepareRoute(outlet)"
  >
    <router-outlet #outlet="outlet" />
  </div>
</div>
